var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScore1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 14,
    viewBox: "0 0 19 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.414426 9.47825V7.60625H9.43243V9.47825H0.414426ZM3.85243 12.8623V4.13225H5.97643V12.8623H3.85243ZM14.1263 12.7183V2.49425L14.7923 3.35825L12.2363 4.65425L11.7143 2.60225L15.1523 0.82025H16.4483V12.7183H14.1263ZM12.0203 13.6003V11.4403H18.6083V13.6003H12.0203Z",
    fill: "#FBBB11"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScore1);
export default __webpack_public_path__ + "static/media/score1.4dbc45da0f2c4a512d23fb4a2397eefd.svg";
export { ForwardRef as ReactComponent };